module.exports = __webpack_public_path__ + "static/media/SRT.73f7b677.png";